import create from '@verndale/core';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import objectFitImages from 'object-fit-images';
import { renderReactModule } from './helpers';
import global from './modules/global';

const modules = [
  {
    name: 'standard-hero',
    loader: () => import('./modules/standard-hero')
  },
  {
    name: 'section-hero',
    loader: () => import('./modules/section-hero')
  },
  {
    name: 'skip-navigation',
    loader: () => import('./modules/skip-navigation')
  },
  {
    name: 'program-detail-hero',
    loader: () => import('./modules/program-detail-hero')
  },
  {
    name: 'blog-news-hero',
    loader: () => import('./modules/blog-news-hero')
  },
  {
    name: 'banner',
    loader: () => import('./modules/banner')
  },
  {
    name: 'generic-overview',
    loader: () => import('./modules/generic-overview')
  },
  {
    name: 'campus-overview',
    loader: () => import('./modules/generic-overview')
  },
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'content-cards',
    loader: () => import('./modules/content-cards')
  },
  {
    name: 'program-cards',
    loader: () => import('./modules/program-cards')
  },
  {
    name: 'tabbed-content',
    loader: () => import('./modules/tabbed-content')
  },
  {
    name: 'diagonal-content',
    loader: () => import('./modules/diagonal-content')
  },
  {
    name: 'catalog-archive',
    loader: () => import('./modules/catalog-archive')
  },
  {
    name: 'find-your-program-form',
    loader: () => import('./modules/find-your-program-form')
  },
  {
    name: 'testimonials-grid',
    loader: () => import('./modules/testimonials-grid')
  },
  {
    name: 'details-locations',
    loader: () => import('./modules/details-locations')
  },
  {
    name: 'academic-calendar',
    loader: () => import('./modules/academic-calendar/academic-calendar')
  },
  {
    name: 'qep',
    loader: () => import('./modules/quality-enhancement-plan/qep')
  },
  {
    name: 'qep-media',
    loader: () => import('./modules/quality-enhancement-plan/qep-media')
  },
  {
    name: 'stats-list',
    loader: () => import('./modules/stats-list')
  },
  {
    name: 'program-listing',
    loader: () => import('./modules/program-listing/index'),
    render(component, el) {
      renderReactModule(component, el);
    }
  },
  {
    name: 'campus-program-listing',
    loader: () => import('./modules/campus-program-listing/index'),
    render(component, el) {
      renderReactModule(component, el);
    }
  },
  {
    name: 'news-blogs-listing',
    loader: () => import('./modules/news-blogs-listing/index'),
    render(component, el) {
      renderReactModule(component, el);
    }
  },
  {
    name: 'testimonials',
    loader: () => import('./modules/testimonials')
  },
  {
    name: 'footer',
    loader: () => import('./modules/footer')
  },
  {
    name: 'international-leads-form',
    loader: () => import('./modules/international-leads-form')
  },
  {
    name: 'rif',
    loader: () => import('./modules/rif')
  },
  {
    name: 'rif-partial',
    loader: () => import('./modules/rif-partial')
  },
  {
    name: 'concerns-form',
    loader: () => import('./modules/concerns-form')
  },
  {
    name: 'financial-info',
    loader: () => import('./modules/financial-info/index'),
    render(component, el) {
      renderReactModule(component, el);
    }
  },
  {
    name: 'featured-blog-news',
    loader: () => import('./modules/featured-blog-news')
  },
  {
    name: 'events-with-overlay',
    loader: () => import('./modules/events-with-overlay')
  },
  {
    name: 'alert-banner',
    loader: () => import('./modules/alert-banner')
  },
  {
    name: 'location-campus-overview',
    loader: () => import('./modules/location-campus-overview')
  },
  {
    name: 'location-campus-program-listing',
    loader: () => import('./modules/location-campus-program-listing')
  },
  {
    name: 'online-learning-card',
    loader: () => import('./modules/online-learning-card')
  },
  {
    name: 'additional-resources',
    loader: () => import('./modules/additional-resources')
  },
  {
    name: 'event-registration-form',
    loader: () => import('./modules/event-registration-form')
  },
  {
    name: 'homepage-hero',
    loader: () => import('./modules/homepage-hero')
  },
  {
    name: 'contact-form',
    loader: () => import('./modules/contact-form')
  },
  {
    name: 'generic-form-row',
    loader: () => import('./modules/generic-form-row')
  },
  {
    name: 'foundation-news-blogs-listing',
    loader: () => import('./modules/foundation-news-blogs-listing'),
    render(component, el) {
      renderReactModule(component, el);
    }
  },
  {
    name: 'faculty-cards',
    loader: () => import('./modules/faculty-cards')
  },
  {
    name: 'tour-site-s-curve',
    loader: () => import('./modules/tour-site-s-curve')
  },
  {
    name: 'tour-site-program-listing',
    loader: () => import('./modules/tour-site-program-listing'),
    render(component, el) {
      renderReactModule(component, el);
    }
  }
];

document.addEventListener('DOMContentLoaded', () => {
  objectFitImages();
  global();
  create(modules);
});
